import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import corporateimage from '../../assets/image/Learning/corporate.jpg'

export default class corporate extends Component {
    render() {
        const image=[
            {image:corporateimage}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='learning-section'>
                    <Banner bread_crum={['Learning','Corporate University Services']} image={image} title="Corporate University Services" subtitle=""/>
                    <br/><br/>
                    <div className='learning-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                            Our Corporate University services provide a complete set of services to support your Corporate University, from planning, preparing, and implementation. These services include conducting learning needs analysis, developing Corporate University road map, developing facilitator’s manual and training modules, implementing structured development initiatives, such as Leadership Development Program, and supporting learning process with various advanced methodologies, such as gamification, board games, and simulations.
                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
